module.exports = __webpack_public_path__ + "static/img/1.510f93c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/4/eng/1.png
// module id = GXln
// module chunks = 0